// Served from web/public (not bundled): these are ~285KB of static PNGs that
// would otherwise ride in the JS bundle every user re-downloads on any code
// change. PUBLIC_URL keeps them correct under a subpath deploy.
const assetBase = `${process.env.PUBLIC_URL}/whats-new`;
const webDropzoneImage = `${assetBase}/web-dropzone.png`;
const shareSheetImage = `${assetBase}/share-sheet.png`;

export type WhatsNewSection = {
  title: string;
  body: string;
  image?: string;
};

export type WhatsNewEntry = {
  id: string;
  // Users created after this date never see the dialog — the feature is
  // not "new" to them.
  publishedAt: string;
  // After this date the news is stale — the dialog no longer appears.
  showUntil: string;
  sections: WhatsNewSection[];
};

export const whatsNewEntry: WhatsNewEntry = {
  id: "2026-07-share-and-web-upload",
  publishedAt: "2026-07-16T00:00:00Z",
  showUntil: "2026-08-31T00:00:00Z",
  sections: [
    {
      title: "Beleg-Upload im Web",
      body: "Ziehe Belege per Drag & Drop auf die Transaktionsliste – Expensly liest sie aus.",
      image: webDropzoneImage,
    },
    {
      title: "Teilen mit Expensly",
      body: "Teile Belege als PDF oder Foto in der mobilen App direkt aus Mail, Fotos oder Dateien mit Expensly – die Belegerfassung öffnet sich automatisch.",
      image: shareSheetImage,
    },
  ],
};

export const pendingWhatsNewEntry = (
  userCreatedAt: string | null | undefined,
  lastSeenId: string | undefined,
  entry: WhatsNewEntry = whatsNewEntry,
  now: Date = new Date()
): WhatsNewEntry | undefined => {
  if (!userCreatedAt) return undefined;
  if (
    new Date(userCreatedAt).getTime() >= new Date(entry.publishedAt).getTime()
  ) {
    return undefined;
  }
  if (now.getTime() >= new Date(entry.showUntil).getTime()) {
    return undefined;
  }
  if (lastSeenId === entry.id) return undefined;
  return entry;
};
